import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import ManagedDisksCalc from '../components/calculators/ManagedDisksCalc'

export default function ManagedDisksPage() {
  return (
    <>
      <Helmet>
        <title>Azure Managed Disks Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure Managed Disks costs for UK South in GBP. Compare Standard HDD, Standard SSD, Premium SSD, Premium SSD v2, and Ultra Disk pricing including transaction charges." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/managed-disks" />
        <meta property="og:title" content="Azure Managed Disks Cost Calculator UK" />
        <meta property="og:description" content="Compare Standard HDD vs SSD transaction cost traps and Premium SSD pricing for Azure UK South." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/managed-disks" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Managed Disks Cost Calculator',
          description: 'Estimate Azure Managed Disks costs for UK South, including HDD vs SSD transaction cost comparison.',
          url: 'https://www.azure-calc.co.uk/managed-disks',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Managed Disks Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Standard HDD/SSD · Premium SSD · Ultra Disk · Transaction costs
          </p>
        </div>

        <ManagedDisksCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>
            Related guides
          </h2>
          <Link
            to="/guides/azure-managed-disks-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold" style={{ color: 'var(--text-secondary)' }}>Azure Managed Disks Pricing Guide UK 2026</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Why Standard HDD can cost more than Standard SSD at any meaningful IOPS level</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
